/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import { StringService } from 'string-service';

/**
 * @description Pipe to capitalize a string.
 *
 * @author Hitesh Mandav
 */

@Pipe({
    name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
    constructor(public readonly stringService: StringService) {}

    /**
     * Transforms first character of string value into uppercase.
     */
    public transform(val: string): string {
        return this.stringService.capitalize(val || '');
    }
}
